import {
  Box,
  CircularProgress,
  CircularProgressLabel,
  Portal,
} from '@chakra-ui/react';
import { loaderSelector } from '@stores/loader';
import { useSelector } from 'react-redux';

export default function GlobalLoader() {
  const { isLoading, text } = useSelector(loaderSelector);
  return (
    <>
      {isLoading && (
        <Portal appendToParentPortal>
          <Box
            display="flex"
            position="fixed"
            alignItems="center"
            justifyContent="center"
            top="0"
            left="0"
            width="100vw"
            height="100vh"
            zIndex="9999"
            background="rgba(0, 0, 0, 0.2)"
          >
            <CircularProgress
              isIndeterminate
              color="#000"
              trackColor="transparent"
              thickness="4px"
            />
            {text !== '' && (
              <CircularProgressLabel color="#fff" mt="32px" fontSize="14px">
                {text}
              </CircularProgressLabel>
            )}
          </Box>
        </Portal>
      )}
    </>
  );
}
